export default "__VITE_ASSET__BeyCUZ9L__"